<template>
    <div class="invoicenoCode">
        <!-- 导航栏 -->
        <topHead>
            <h3 slot="header" @click="go">实名验证</h3>
        </topHead>
    </div>
</template>

<script>
import { Toast } from "vant"
import API from "../../../common/api/api"
import Lanmao from "../../../components/lanmao/index"
import topHead from "../../../components/topHead.vue"
export default {
    components: {
        topHead
    },
    data() {
        return {
            phone: "",
            biz_no: "",
        }
    },

    created() { },
    // 组件方法
    methods: {
        go() {
            this.$router.push("/invoiceVerify")
        },

    },

    computed: {},

    watch: {},

    mounted() { },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            Lanmao.loading.show("数据上传中")
            API.getJson('NEW_INVOICE_OCR_RESULT', {
                biz_no: sessionStorage.getItem("biz_no")
            }).then(res => {
                if (res.data) {
                    if (res.data.code != 1) {
                        Toast({
                            message: res.data.msg,
                            position: "bottom",
                        })
                        Lanmao.loading.hide()
                        next({ path: "/invoiceVerify" })
                    }
                } else {
                    if (res.biz_no != "") {
                        Toast({
                            message: "身份核验成功",
                            position: "bottom",
                            duration: 800,
                        })
                        vm.biz_no = res.biz_no
                        localStorage.setItem("Phone", res.serviceId)
                        sessionStorage.removeItem("biz_no")
                        Lanmao.loading.hide()
                        next({ path: "/invoiceList" })
                    }
                }
            })
        })
    },
}
</script>

<style scoped lang='scss'>
.invoicenoCode {
    height: 100%;
    box-sizing: border-box;
    box-shadow: 0 px2rem(5) px2rem(10) rgba(0, 0, 0, 0.3);
    border: none !important;

    .topHead {
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        background: #fff;
        z-index: 99;
    }
}
</style>